import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap } from 'lucide-react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/checkout';
const includes = ['Tomo 1 — Fundamentos de la Producción Agropecuaria', 'Tomo 2 — Producción Vegetal y Ganadería Bovina', 'Tomo 3 — Riego, Maquinaria y Seguridad Rural', 'Tomo 4 — Sustentabilidad y Producción Animal', 'Tomo 5 — Del Campo al Mercado', 'Bono 1 — Clases organizadas y listas para usar', 'Bono 2 — Actividades prácticas para el aula y el taller', 'Bono 3 — Evaluaciones y criterios de corrección', 'Bono 4 — Proyectos Finales Productivos'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-192" data-mp="226i0y4oo93ao">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-forest/10 blur-[120px] rounded-full pointer-events-none" data-id="element-193" data-mp="2v8pdyqqt4gq"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194" data-mp="1mgofre9i7flx">
        <div className="text-center mb-10" data-id="element-195" data-mp="1mi99x2rwowj9">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-slate-900" data-id="element-196" data-mp="1hpy6hpxyisly">
            Accedé a tu Mega Pack
          </h2>
          <p className="text-earth text-sm md:text-base font-medium" data-id="element-197" data-mp="1crwq5crx17e6">
            Pago único. Acceso inmediato.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.15)]" data-id="element-198" data-mp="17ppbugjm5f8o">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-forest text-cream font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs whitespace-nowrap" data-id="element-199" data-mp="1rezmvh8ezc0g">
            🏆 Oferta principal
          </div>

          <div className="bg-cream rounded-[1.3rem] p-6 md:p-10 text-center border border-white" data-id="element-200" data-mp="g2yvrvo2vbhj">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-forest mb-3" data-id="element-201" data-mp="hfx7ji2w53ij">
              Mega Pack Educación Agropecuaria en el Aula
            </h3>
            <p className="text-base text-slate-700 mb-6" data-id="element-202" data-mp="7isk7exb7205">
              Los 5 tomos + 4 bonos estratégicos listos para usar en el aula.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-white border border-earth/10 rounded-xl p-4 shadow-sm" data-id="element-203" data-mp="3uwo1xxb78mva">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-204" data-mp="3k37lok3hohk" data-mpi={i}>
                  <Check size={16} className="text-forest shrink-0 mt-0.5" data-id="element-205" data-mp="3px1t002elssa" />
                  <span data-id="element-206" data-mp="3bxsb8vyjuqm7">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-207" data-mp="3c066b4t8c2tr">
              <span className="text-lg text-slate-500 line-through block mb-1" data-id="element-208" data-mp="3fznbry8nozyx">
                USD 45,00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-209" data-mp="2xbwfrnbvgou9">
                <span className="text-2xl md:text-3xl text-slate-800" data-id="element-210" data-mp="2scs5suh4in2v">
                  Hoy:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-forest" data-id="element-211" data-mp="36ckruchpgf4i">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-212" data-mp="3g9pd8a3q86k9">
              🟡 QUIERO EL MEGA PACK
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-600 font-medium mb-5" data-id="element-213" data-mp="3p1hjs9pmqvjk">
              <span className="flex items-center gap-1.5" data-id="element-214" data-mp="3l31svuqfh30v">
                <Lock size={12} className="text-forest" data-id="element-215" data-mp="2vuipoqttlyl" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216" data-mp="3u2f1yman3pl2">
                <Zap size={12} className="text-forest" data-id="element-217" data-mp="hy2lsyu0a109" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218" data-mp="lzo7n9oippml">
                <Shield size={12} className="text-forest" data-id="element-219" data-mp="ly4onbbh90h4" /> Garantía 7 días
              </span>
            </div>

            <div className="bg-white border border-earth/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left shadow-sm" data-id="element-220" data-mp="qr653nrc182t">
              <Globe className="text-forest shrink-0 mt-0.5" size={14} data-id="element-221" data-mp="3v4w1yqouc8ni" />
              <p className="text-[11px] text-slate-600 leading-snug" data-id="element-222" data-mp="3v6yy7sgl6y0o">
                Pagás en tu moneda local. El importe se adapta automáticamente
                al país desde donde comprás.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}